import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthFirebaseService } from '../../../auth-firebase.service';
import { Router } from '@angular/router';
import { AskRolService } from '../../../ask-rol.service';


@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = [ { title: 'Cerrar Sesión',action:'closeSession' } ];
  subscription: any;
  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private themeService: NbThemeService,
              private userService: UserData,
              private layoutService: LayoutService,
              private breakpointService: NbMediaBreakpointsService,
              private authService: AuthFirebaseService,
              private router: Router,
              private cdr: ChangeDetectorRef,
              public askRolService: AskRolService) {
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    this.authService.getAdminData()
      .pipe(takeUntil(this.destroy$))
      .subscribe((admin: any) => {
        this.user = admin;
        this.cdr.detectChanges();
      });

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

      this.subscription = this.menuService.onItemClick().subscribe((event) => {
        const evItem = event.item as any;
        if( evItem.action == 'closeSession'){
          this.authService.closeSession();
          this.router.navigate(['auth','login']);
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  gotoLogin(){
    this.router.navigate(['auth','login']);
  }

  newRecord() {
    this.router.navigate(['/pages/nuevo-registro']);
  }

  newTask() {
    this.router.navigate(['/pages/nueva-tarea']);
  }

}
